var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"link",attrs:{"href":_vm.link}},[_c('p',{staticClass:"footer"},[_vm._v("Built by Fajar Pambudhi | Made With Vuejs")])])])}
var staticRenderFns = []

export { render, staticRenderFns }